import React from "react";
import "./ActionSettingsRow.css";
import { IReducer } from "../../state/reducer";

interface ActionSettingsRowProps extends IReducer {
  id: string;
  title: string;
  type:
    | "Collect"
    | "Create"
    | "Split"
    | "Capacity"
    | "Auto Collect"
    | "BrickPack";
  userHidden: boolean;
}

const ActionSettingsRow: React.FC<ActionSettingsRowProps> = ({
  id,
  title,
  type,
  userHidden,
  dispatch,
}) => {
  const typeClass = `actionType${type.charAt(0).toUpperCase() + type.slice(1)}`;

  const handleToggle = () => {
    dispatch({
      type: "TOGGLE_ACTION_USER_VISIBILITY",
      actionId: id,
    });
  };

  return (
    <div className={`noSelect actionSettingsRowContainer ${typeClass}`}>
      <div className="actionSettingsRowContent">
        <div className="actionSettingsRowHeader">
          <span className="actionSettingsRowType">
            {type === "Capacity" ? "Increase Capacity" : type}
          </span>
          <div className="actionSettingsRowTitle">{title}</div>
        </div>
        <div className="actionToggleButtonContainer">
          <button
            className={`actionToggleButton ${userHidden ? "actionToggleOff" : "actionToggleOn"}`}
            onClick={handleToggle}
          >
            {userHidden ? "Hidden" : "Visible"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionSettingsRow;
